var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { id: "classesView", tag: "section" } },
    [
      _c(
        "v-overlay",
        {
          staticClass: "waitoverlay",
          attrs: { value: _vm.busy || _vm.contentLibraryLoading }
        },
        [
          _c("v-progress-circular", {
            staticClass: "mr-4",
            attrs: { indeterminate: "", size: "64" }
          }),
          _vm._v(
            " " +
              _vm._s(
                _vm.contentLibraryLoading
                  ? "Loading content library..."
                  : _vm.$t("global.loading")
              ) +
              " "
          )
        ],
        1
      ),
      _c("h1", [_vm._v(_vm._s(_vm.$t("dashboard.title", [_vm.accountName])))]),
      _vm.accountExpired
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "text-center text-white pt-10",
                      attrs: { color: "red" }
                    },
                    [
                      _c("h1", [
                        _vm._v(
                          _vm._s(_vm.$t("dashboard.account-expired-message"))
                        )
                      ]),
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("dashboard.account-expired-message2"))
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4" } },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(_vm._s(_vm.$t("dashboard.users")))
                  ]),
                  _c("v-card-text", [
                    _c("div", {
                      staticClass: "quota",
                      domProps: {
                        innerHTML: _vm._s(_vm.getUsageQuota("Users"))
                      }
                    })
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4" } },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(_vm._s(_vm.$t("dashboard.sessions")))
                  ]),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "div",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "quota",
                                          attrs: { "aria-expanded": false },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.getUsageQuota("Sessions")
                                            )
                                          }
                                        },
                                        "div",
                                        attrs,
                                        false
                                      ),
                                      on
                                    )
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.sessionsCompleted))])]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4" } },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(_vm._s(_vm.$t("dashboard.devices")))
                  ]),
                  _c("v-card-text", [
                    _c("div", {
                      staticClass: "quota",
                      domProps: {
                        innerHTML: _vm._s(_vm.getUsageQuota("Devices"))
                      }
                    })
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "8" } },
            [
              !_vm.youraccount
                ? _c(
                    "shortcode-generator",
                    {
                      attrs: {
                        title: _vm.$t("dashboard.generate-code"),
                        action: "trial",
                        account: _vm.account
                      }
                    },
                    [
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("dashboard.generate-code-instructions")
                          )
                        }
                      })
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _c("v-col")
        ],
        1
      ),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "mb-0" },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _vm._v(" " + _vm._s(_vm.$t("summary")) + " "),
                      _c("v-spacer")
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c("date-range-picker", {
                        on: { datesChange: _vm.datesChanged }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-4",
                          attrs: {
                            color: "success",
                            "aria-label": _vm.$t("dashboard.download-summary")
                          },
                          on: { click: _vm.exportAsPdf }
                        },
                        [_c("v-icon", [_vm._v("mdi-download")])],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              !_vm.contentLibraryLoading
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        [
                          _c("platform-usage", {
                            attrs: {
                              id: "platformUsage",
                              "start-date": _vm.startDate,
                              "end-date": _vm.endDate,
                              scope: "account"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.contentLibraryLoading
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        [
                          _c("module-survey-explorer", {
                            attrs: {
                              id: "successFactors",
                              "start-date": _vm.startDate,
                              "end-date": _vm.endDate,
                              scope: "account"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      !_vm.youraccount && !_vm.contentLibraryLoading
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c("user-list", {
                    attrs: {
                      title: _vm.$t("dashboard.administrators"),
                      roles: _vm.adminAssignableRoles,
                      account: _vm.account
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }